module.exports = __webpack_public_path__ + "static/media/group_folder.94ce98c5.png";